import { render, staticRenderFns } from "./kvartalalley.vue?vue&type=template&id=001bb9fa&"
import script from "./kvartalalley.vue?vue&type=script&lang=js&"
export * from "./kvartalalley.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports